<u-tab-view
  [hasDelayTab]="hasDelayTab"
  [tabsStatic]="staticTabs"
  [tabsMoving]="movingTabs"
  [tabsActionStatic]="isOwnerOrAdmin ? staticActionTabs : []"
  (onChangeActiveTab)="setActiveTab($event.tab)"
  [selectedTabId]="currentTabId"
  (onAction)="onTabAction($event)"
  (onOpenContextMenu)="openContextMenu($event)"
  (onItemsOrderChange)="itemsOrderChange($event)"
  [ngClass]="{ 'focused-tab': methodsList[selectedIndex]?.id === 'tab' }"
  [isPrimary]="false"
  [contentMaxWidth]="169"
>
  <div class="tabs-view-content">
    <avatar-list
      class="avatar-list"
      [ngClass]="{ 'no-share-button': currentTab?.disabled && isOwnerOrAdmin }"
      *ngIf="avatarsList?.length > 0"
      [model]="avatarsList"
      tooltipHeader="SHARED WITH"
      [spreadAvatarsCount]="3"
      [tooltipLimit]="99"
      [sizeAvatarTooltip]="'16px'"
    ></avatar-list>
    <u-button
      *ngIf="currentTab?.disabled === false && isOwnerOrAdmin"
      class="no-border-button"
      label="Share"
      type="secondary"
      elementSize="very-small"
      (click)="handleCommand({ id: 'share' }, currentTab)"
      tooltipPosition="bottom"
      pTooltip="Share tab with your team"
      tooltipStyleClass="u-tooltip"
      [ngClass]="{ focused: methodsList[selectedIndex]?.id === 'share' }"
    ></u-button>
    <square-button
      #contextMenu
      *ngIf="isOwnerOrAdmin"
      [active]="contextMenuOpened"
      (click)="$event.stopPropagation(); openContextMenu({ event: $event, tabId: currentTab.id })"
      (auxclick)="$event.stopPropagation(); openContextMenu({ event: $event, tabId: currentTab.id })"
      (contextmenu)="$event.stopPropagation(); openContextMenu({ event: $event, tabId: currentTab.id })"
      [ngClass]="{ focused: methodsList[selectedIndex]?.id === 'context_menu' }"
      >•••</square-button
    >
  </div>
</u-tab-view>
